<!-- TODO need optimization for clean group -->
<template>
  <div class="form-generator">
    <b-form ref="forms">
      <template v-if="withGroups">
        <div class="row row-group form-generator__items" v-for="(group, key, index) in fields.groups" :key="index">
          <div class="col col-12 form-generator__group-name">{{group.name}}</div>
          <FormGeneratorItems
            v-for="(field, key) in group.fields"
            :field="field"
            :key="key"
            v-model="field.value"
            :validation="$v.fields[key]"
            @update="updateItem"
            @keyDown="keyDown"
          >
            <slot
              :name="field.slotName"
              :data="field"
              :fields="fields"
            >
            </slot>
            <template v-slot:errors v-if="$v.fields[key]">
              <ErrorMessage :value="$v.fields[key].value" :field="group.fields[key]" :allFields="fields" />
            </template>
          </FormGeneratorItems>
        </div>
      </template>
      <div class="row form-generator__items" v-else>
        <FormGeneratorItems
          v-for="(field, key) in fields"
          v-show="!field.hidden"
          :field="field"
          :key="key"
          v-model="field.value"
          :validation="$v.fields[key]"
          @update="updateItem"
          @keyDown="keyDown"
        >
        <template >
      </template>
          <slot
            :name="field.slotName"
            :data="field"
            :fields="fields"
          >
          </slot>
          <template v-slot:errors v-if="$v.fields[key]">
            <ErrorMessage :value="$v.fields[key].value" :field="fields[key]" :allFields="fields" />
          </template>
        </FormGeneratorItems>
      </div>
      <div class="row form-generator__items" v-if="showAddItems">
        <div class="row col-12 align-items-end" v-for="(item, key) in extraItems" :key="key">
          <FormGeneratorItems
            v-for="field in item"
            :field="field"
            :key="`${key}-${field.name}`"
            v-model="field.value"
            @update="updateItem"
          >
            <slot
              :name="field.slotName"
              :data="field"
              :fields="fields"
            >
            </slot>
            <template v-slot:errors v-if="$v.fields[key]">
              <ErrorMessage :value="$v.fields[key].value" />
            </template>
          </FormGeneratorItems>
          <b-button
            variant="secondary"
            class="button btn-icon ml-auto btn-item-delete"
            @click="deleteItem(key)"
          >
            <span v-html="removeIconSvg"></span>
          </b-button>
        </div>
        <b-button @click.prevent="addItem" variant="info">
          Add {{ extraOptions.addBtn }}
        </b-button>
      </div>
      <div class="row form-generator__controls" v-if="showFormControls">
        <div class="col">
          <div class="form-generator-buttons">
            <slot name="form-footer-left-controllers"></slot>
            <b-button
              :disabled="isLoading"
              type="reset"
              variant="outline"
              class="button form-generator__button mr-2"
              @click.prevent="resetForm"
              v-if="showReset"
            >
              {{ textButtonReset }}
            </b-button>
            <b-button
              v-if="isShowSubmitBtn"
              :disabled="isLoading"
              @click.prevent="submit"
              variant="primary"
              class="button form-generator__button"
            >
              {{textButtonSubmit}}
            </b-button>
            <slot name="form-footer-controllers"></slot>
          </div>
        </div>
        <slot name="footer-controllers"></slot>
      </div>
    </b-form>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { validationMixin } from 'vuelidate'
import { formValidators } from '@forms/constants'
import FormGeneratorItems from '@components/FormGeneratorItems'
import ErrorMessage from '@forms/ErrorMessage.vue'
import removeIcon from '@/assets/icons/removeIcon'

export default {
  name: 'FormGenerator',
  components: { ErrorMessage, FormGeneratorItems },
  mixins: [validationMixin],
  validations () {
    return {
      ...this.validationRules
    }
  },
  data () {
    return {
      removeIconSvg: removeIcon(),
      fields: {},
      extraItems: []
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    withGroups: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    showFormControls: {
      type: Boolean,
      default: true
    },
    showReset: {
      type: Boolean,
      default: true
    },
    textButtonSubmit: {
      type: String,
      default: 'Submit'
    },
    textButtonReset: {
      type: String,
      default: 'Reset'
    },
    extraOptions: {
      type: Object,
      default: () => ({})
    },
    extraItem: {
      type: Object,
      default: () => ({})
    },
    isShowSubmitBtn: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    'data': {
      deep: true,
      handler () {
        if (JSON.stringify(this.fields) !== JSON.stringify(this.data)) {
          this.setInitialForm()
        }
      }
    },
    'fields': {
      deep: true,
      handler () {
        this.$emit('input', this.fields)
      }
    }
  },
  created () {
    this.setInitialForm()
  },
  computed: {
    validationRules () {
      let result = { fields: {} }

      for (let key in this.data) {
        if (key === 'items' && (
          this.fields.invoice_type && this.fields.invoice_type.value && this.fields.invoice_type.value.type !== 'hourly'
        )) {
          continue
        }
        if (key === 'periods' && this.fields.invoice_type.value && this.fields.invoice_type.value.type !== 'period') {
          continue
        }
        if (key === 'specialisations' && this.fields.invoice_type.value && this.fields.invoice_type.value.type !== 'specialisation') {
          continue
        }

        if (typeof this.data[key].skipValidation === 'function' && this.data[key].skipValidation(this.fields)) {
          continue
        }

        if (this.data[key].validation) {
          result.fields[key] = {
            value: {}
          }

          this.data[key].validation.map((validateItem) => {
            result.fields[key].value[validateItem.name] = formValidators[validateItem.name](validateItem.params, this.fields)
          })
        }
      }

      return result
    },
    showAddItems () {
      if (!Object.keys(this.extraOptions).length) {
        return false
      }
      const triggerField = this.extraOptions.triggerField
      const triggerValue = this.extraOptions.triggerValue

      if (this.fields[triggerField].value && this.fields[triggerField].value.type === triggerValue) {
        return true
      }

      return false
    }
  },
  methods: {
    updateItem (itemName, fieldData) {
      this.$emit('updateItem', itemName, fieldData)
    },
    keyDown (event) {
      if (event.key === 'Enter') {
        event.preventDefault()
        this.submit()
      }
    },
    submit () {
      this.validateForm()
      if (!this.$v.$invalid) {
        const fields = JSON.parse(JSON.stringify(this.fields))
        if (this.extraOptions.keySubmit/* && this.extraItems.length */) {
          fields[this.extraOptions.keySubmit] = this.extraItems
        }

        this.$emit('submit', fields)
      }
    },
    validateForm () {
      this.$v.$touch()
    },
    cleanField (fieldName, indexItem, group) {
      const field = group ? this.fields.groups[group].fields[fieldName] : this.fields[fieldName]
      const isArrayField = Array.isArray(field.value)
      let newFieldValue = isArrayField && field.type !== 'range_slider'
        ? field.value.filter((item, index) => index !== indexItem) : null

      if (group) {
        this.fields.groups[group].fields[fieldName] = {
          ...field,
          value: newFieldValue
        }
      } else {
        this.fields[fieldName] = {
          ...field,
          value: newFieldValue
        }
      }

      this.updateItem(fieldName, { ...field, value: newFieldValue })
    },
    cleanForm () {
      for (let key in this.fields) {
        const field = this.fields[key]
        this.fields[key].value = Array.isArray(field.value) && field.type !== 'range_slider' ? [] : null
      }

      this.$emit('clean', this.fields)
    },
    cleanFormWithGroups () {
      for (let groupKey in this.fields.groups) {
        for (let fieldKey in this.fields.groups[groupKey].fields) {
          const field = this.fields.groups[groupKey].fields[fieldKey]
          this.fields.groups[groupKey].fields[fieldKey].value = Array.isArray(field.value) && field.type !== 'range_slider' ? [] : null
        }
      }

      this.$emit('clean', this.fields)
    },
    resetForm () {
      this.fields = cloneDeep(this.data)
      this.$emit('reset', this.fields)
    },
    setInitialForm () {
      this.fields = cloneDeep(this.data)

      if (Object.keys(this.extraOptions).length &&
        this.extraOptions.keySubmit !== undefined &&
        this.fields[this.extraOptions.keySubmit] !== undefined) {
        const extraOptionFieldName = this.extraOptions.keySubmit

        for (const extraOptionItemKey in this.fields[extraOptionFieldName]) {
          const extraOptionItem = this.fields[extraOptionFieldName][extraOptionItemKey]
          const item = JSON.parse(JSON.stringify(this.extraItem))

          for (const itemFieldName in item) {
            let itemFieldItem = item[itemFieldName]
            if (itemFieldItem.type === 'select') {
              item[itemFieldName].value = itemFieldItem.options.find(itemFieldItemOption => itemFieldItemOption.id === extraOptionItem[itemFieldName])
            } else {
              item[itemFieldName].value = extraOptionItem[itemFieldName]
            }
          }
          this.extraItems.push(item)
        }
        delete this.fields[extraOptionFieldName]
      }
    },
    setInitialFormWithGroups () {
      this.fields = cloneDeep(this.data)
      if (Object.keys(this.extraOptions).length &&
        this.extraOptions.keySubmit !== undefined) {
        const extraOptionFieldName = this.extraOptions.keySubmit

        if (this.fields[extraOptionFieldName] !== undefined) {
          for (const extraOptionItemKey in this.fields[extraOptionFieldName]) {
            const extraOptionItem = this.fields[extraOptionFieldName][extraOptionItemKey]
            const item = JSON.parse(JSON.stringify(this.extraItem))

            for (const itemFieldName in item) {
              let itemFieldItem = item[itemFieldName]
              if (itemFieldItem.type === 'select') {
                item[itemFieldName].value = itemFieldItem.options.find(itemFieldItemOption => itemFieldItemOption.id === extraOptionItem[itemFieldName])
              } else {
                item[itemFieldName].value = extraOptionItem[itemFieldName]
              }
            }
            this.extraItems.push(item)
          }
          delete this.fields[extraOptionFieldName]
        }
      }
      if (this.fields.groups) {
        for (let groupKey in this.fields.groups) {
          this.fields.groups[groupKey].fields = cloneDeep(this.data.groups[groupKey].fields)
        }
      }
    },
    addItem () {
      const item = JSON.parse(JSON.stringify(this.extraItem))
      this.extraItems.push(item)
    },
    deleteItem (key) {
      this.extraItems.splice(key, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-item-delete {
    margin-bottom: 15px;
  }
</style>
